import styled from '@emotion/styled';

const TextBlock = styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-family: Inter;
  font-size: 16px;
  line-height: 30px;
  margin: 0 -16px;
  padding: 0 16px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    padding: 0 ${(props) => props.theme.padding};
    margin: 0 -${(props) => props.theme.padding};
  }

  h2 {
    padding: 0;
    margin: 0 0 16px;
    color: ${(props) => props.theme.colors.primary};
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    line-height: 30px;
    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 24px;
      margin-bottom: ${(props) => props.theme.padding};
    }
  }

  ul {
    padding: 0 16px;
  }

  p {
    margin-bottom: 16px;
  }

  li {
    margin-bottom: 12px;
    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      margin-bottom: 16px;
    }
  }
`;

export { TextBlock };
